import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular/standalone';
import { of } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class CustomSpinnerService {
	isLoading = false;
	active = 0;
	testVal = Math.random();

	constructor(public loader: LoadingController) {
	}

	// public async show(needChecking = true) {
	// 	if (!this.isLoading) {
	// 		console.log('show', this.isLoading);
	// 		this.isLoading = true;
	// 		return await this.loader.create({
	// 			spinner: 'dots',
	// 			duration: needChecking ? 8000 : 100000000,
	// 			cssClass: 'loading-class',
	// 		}).then(a => {
	// 			a.present().then(() => {
	// 				// console.log('presented', this.isLoading);
	// 				if (!this.isLoading) {
	// 					a.dismiss().then(() => {
	// 						// console.log('abort presenting');
	// 					});
	// 				}
	// 			});
	// 		});
	// 	}
	// }

	public async show(needChecking = true, message = '') {

		return of(1)
			.pipe(
				filter(() => this.isLoading === false),
				tap(() => this.isLoading = true),
				switchMap(() => this.loader.create({
					spinner: 'dots',
					duration: needChecking ? 8000 : 100000000,
					message,
					cssClass: 'loading-class',
				})),
				tap((a) => {
					a.present().then(() => {
						if (!this.isLoading) {
							a.dismiss().then(() => {
								// console.log('abort presenting');
							});
						}
					});
				})
			).toPromise();

		// if (!this.isLoading) {
		// 	console.log('show', this.isLoading);
		// 	this.isLoading = true;
		// 	return await this.loader.create({
		// 		spinner: 'dots',
		// 		duration: needChecking ? 8000 : 100000000,
		// 		cssClass: 'loading-class',
		// 	}).then(a => {
		// 		a.present().then(() => {
		// 			// console.log('presented', this.isLoading);
		// 			if (!this.isLoading) {
		// 				a.dismiss().then(() => {
		// 					// console.log('abort presenting');
		// 				});
		// 			}
		// 		});
		// 	});
		// }
	}

	public async hide(timeOut = 300) {
		console.log('loader hide!')
		return new Promise<void>(next => {
			if (this.isLoading) {
				setTimeout(() => {
					this.isLoading = false;
					return this.loader.dismiss().then(() => {
						next();
					}).catch(r => {
						console.log('loader error', r);
						next();
					});
				}, timeOut);
			} else {
				next();
			}
		});
	}
}
